import { Helmet } from "react-helmet-async";

export default function SEOHead({
    title,
    description,
    canonical,
    image,
    type = "website",
}) {
    const fullTitle = title
        ? `${title} | Weed Dispensary Near Me`
        : "Weed Dispensary Near Me | ZenZest NY";

    return (
        <Helmet prioritizeSeoTags>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {canonical && <link rel="canonical" href={canonical} />}
            <meta property="og:title" content={fullTitle} />
            {description && (
                <meta property="og:description" content={description} />
            )}
            <meta property="og:type" content={type} />
            {image && <meta property="og:image" content={image} />}
            {canonical && <meta property="og:url" content={canonical} />}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && (
                <meta name="twitter:description" content={description} />
            )}
            {image && <meta name="twitter:image" content={image} />}
            <meta name="robots" content="index, follow" />
            <meta name="theme-color" content="#0A120D" />
        </Helmet>
    );
}
